import { useMutation } from '@apollo/client';
import { deleteWishListStudio } from '../../graphql/mutations/wishlistMutations';

export const useDeleteWishListStudio = () => {
  const [deleteWishlistStudioMutation, { loading, error }] = useMutation(deleteWishListStudio, {
    refetchQueries: ['WishListsByUserID'],
    awaitRefetchQueries: true
  });

  const sanitizeInput = (input = {}) => {
    const cleaned = { ...input };
    Object.keys(cleaned).forEach((key) => {
      if (cleaned[key] === undefined) {
        delete cleaned[key];
      }
    });
    return cleaned;
  };

  const handleWishlistStudioDeletion = async (wishlistStudioId) => {
    try {
      if (!wishlistStudioId) {
        throw new Error('WishlistStudio ID is required');
      }

      const input = sanitizeInput({ id: wishlistStudioId });

      const { data: response } = await deleteWishlistStudioMutation({
        variables: { input }
      });

      return response?.deleteWishListStudio;
    } catch (error) {
      console.error('Error deleting wishlist studio:', error);
      throw error;
    }
  };

  return {
    handleWishlistStudioDeletion,
    loading,
    error
  };
};